import BackendService from '../services/backendService';
import { NewPresentationMetadata } from '../services/backendService/types';

export const createBlankPresentation = async (
  metadata?: NewPresentationMetadata,
  maxRetries = 3,
): Promise<{ id: string; livePresentationId: string } | null> => {
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      return await BackendService.instance.presentations.newPresentationId(metadata);
    } catch {
      if (attempt === maxRetries) return null;
      await new Promise(resolve => setTimeout(resolve, 500 * attempt));
    }
  }
  return null;
};

/**
 * A "connection error" is a request that never received a response — a dropped
 * connection or timeout, where axios leaves `error.response` undefined. It's
 * distinct from a server error (4xx/5xx, which carries a `response`): on a
 * dropped connection the backend has usually still created the lesson, so the
 * generation-error popup reassures + points to My Lessons; on a server error it
 * doesn't (nothing was created). See CURI-362.
 */
export const isConnectionError = (error: unknown): boolean =>
  !!error && !(error as { response?: unknown }).response;

export const formatPin = (pin?: string | null): string => {
  if (!pin) return '';
  const middle = Math.floor(pin.length / 2);
  return `${pin.slice(0, middle)} ${pin.slice(middle)}`;
};
